import React, { useRef, useState } from "react";
import styles from "./styles.module.scss";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import styled from "styled-components";
import { useForm, set } from "react-hook-form";
import Joi from "joi";
import { joiResolver } from "@hookform/resolvers/joi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Send = styled.div`
  visibility: ${({ clicked }) => (clicked ? "visible" : "hidden")};
  display: ${({ clicked }) => (clicked ? "contents !important" : "none")};
`;

const validateWithJoi = (schema) => (values) => {
  let errors = {};
  const { error: joiError } = schema.validate(values, { abortEarly: false });
  if (!joiError) return null;

  joiError.details.forEach(({ path, message }) =>
    set(errors, path[0], message)
  );

  return errors;
};

const Contact = () => {
  const JoiSchema = Joi.object({
    user_name: Joi.string().required().label("Name"),
    user_email: Joi.string().email({ tlds: false }).required().label("Email"),
    user_subject: Joi.string().required().label("Subject"),
    message: Joi.string().required().min(20).label("Message"),
  });

  const formRef = useRef();

  const [done, setDone] = useState(false);
  const [clicked, setClicked] = useState(false);

  const formOptions = { resolver: joiResolver(JoiSchema) };

  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState;

  async function onSubmit() {
   
    let templateParams = {
      user_name: formRef.current.user_name.value,
      message: formRef.current.message.value,
      user_email: formRef.current.user_email.value,
      user_subject: formRef.current.user_subject.value,
    };
    console.log(templateParams);
    try {
      await emailjs
        .send(
          "service_okw1gzy",
          "template_s096dhy",
          templateParams,
          "DmjAsI0kX04gncf5U"
        )
        .then(
          function (response) {
            toast.success(" Email envoyer avec succée ! ", {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            console.log("SUCCESS!", response.status, response.text);
            setDone(true);
            
          },
          function (err) {
            toast.error(" Erreur, Essayer plus tard ! ", {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            console.log("FAILED...", err);
          }
        );
    } catch (error) {
      console.error(error);
    }
  }
  const onError = (errors, e) => {};

  let verifyCallback = function (response) {
    if (response) {
      setClicked(true);
    }
  };

  return (
    <>
      <div className={styles.c_bg}></div>
      <div className={styles.c_wrapper}>
        <div className={styles.c_left}>
          <h1 className={styles.c_title}>VOUS AVEZ UN PROJET IT ?</h1>
          <div className={styles.c_info}>
            <div className={styles.c_info_item}>
              <img src="/images/phone.png" alt="" className={styles.c_icon} />
              +33782464988
            </div>

            <div className={styles.c_info_item}>
              <img className={styles.c_icon} src="/images/email.png" alt="" />
              hello@orgaexpert.fr
            </div>
            <div className={styles.c_info_item}>
              <img className={styles.c_icon} src="/images/address.png" alt="" />
              Rue De La Mairie 37520 La Riche, France
            </div>
          </div>
        </div>
        <div className={styles.c_right}>
          <p className={styles.c_desc}>
            <b>NOUS CONTACTER</b> Nous serons ravis de répondre à vos demandes
            d’informations ainsi qu'à vos besoins pour réussir un projet.
          </p>
          <hr className={styles.style11} />
          <p className={styles.c_desc}>
            Obtenez une réponse dans les 24 heures
          </p>
          <form ref={formRef}>
            <input
              type="text"
              placeholder="Nom"
              name="user_name"
              required
              {...register("user_name")}
            />
            {errors.user_name && <p>Veuillez ecrire votre nom</p>}
            <input
              type="text"
              placeholder="Sujet"
              name="user_subject"
              required
              {...register("user_subject")}
            />
            {errors.user_subject && <p>Veuillez mentionner l'objet du mail</p>}
            <input
              type="text"
              placeholder="Email"
              name="user_email"
              required
              {...register("user_email")}
            />
            {errors.user_email && (
              <p>Veuillez ecrire une adresse mail valide</p>
            )}
            <textarea
              rows="5"
              placeholder="Message"
              name="message"
              required
              {...register("message")}
            />
            {errors.message && (
              <p>Veuillez ecrire un message de minimum 20 caracteres</p>
            )}
            {/* <button type="submit" value="Send an email"/> */}
            <ReCAPTCHA
              sitekey="6LfTP-4gAAAAALOWx-qVD2vTYYBmcSyBt0pV2Svy"
              theme="dark"
              onChange={verifyCallback}
            />

            <Send clicked={clicked} onClick={handleSubmit(onSubmit, onError)}>
              <a className={styles.btn}>
                <span>Envoyer</span>
                <em></em>
              </a>
            </Send>

          </form>
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          
        </div>
      </div>
    </>
  );
};

export default Contact;
